(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/game-analyzes/assets/javascripts/game-analyzes.js') >= 0) return;  svs.modules.push('/components/sport/game-analyzes/assets/javascripts/game-analyzes.js'); 'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CACHE_EXPIRE = 5 * 60 * 1000;
var gameAnalyzes = {};
var logger = new svs.core.log.Logger('svs.sport.gameAnalyzes');

var mapGameAnalyzes = function mapGameAnalyzes(gameAnalyzes) {
  return gameAnalyzes.map(function (gameAnalysis) {
    var toAppend = {
      awaySelected: false,
      drawSelected: false,
      homeSelected: false
    };

    if (gameAnalysis && gameAnalysis.properties && gameAnalysis.properties.cnt_gamePrediction && typeof gameAnalysis.properties.cnt_gamePrediction === 'string') {
      var prediction;

      try {
        prediction = JSON.parse(gameAnalysis.properties.cnt_gamePrediction);
      } catch (error) {
        logger.warn("Error when trying to parse prediction data: ".concat(error));
      }

      if (prediction && prediction.prediction && Array.isArray(prediction.prediction) && prediction.prediction.length > 0 && prediction.prediction[0]) {
        var predictionItem = prediction.prediction[0];

        if (predictionItem.system === 'SROW') {
          var predictedOutcomes = predictionItem.outcomes;

          if (predictedOutcomes && Array.isArray(predictedOutcomes)) {
            toAppend.homeSelected = predictedOutcomes.indexOf('1') > -1;
            toAppend.drawSelected = predictedOutcomes.indexOf('X') > -1;
            toAppend.awaySelected = predictedOutcomes.indexOf('2') > -1;
          }
        }
      }
    }

    return _objectSpread({}, gameAnalysis, {}, toAppend);
  });
};

var mapDrawAnalyzes = function mapDrawAnalyzes(gameAnalyzes) {
  return gameAnalyzes.map(function (gameAnalysis) {
    return _objectSpread({}, gameAnalysis, {
      gameAnalyses: (gameAnalysis.gameAnalyses || []).map(function (eventAnalysis) {
        var toAppend = {
          awaySelected: false,
          drawSelected: false,
          homeSelected: false
        };

        if (eventAnalysis && eventAnalysis.properties && eventAnalysis.properties.cnt_gamePrediction && typeof eventAnalysis.properties.cnt_gamePrediction === 'string') {
          var prediction;

          try {
            prediction = JSON.parse(eventAnalysis.properties.cnt_gamePrediction);
          } catch (error) {
            logger.warn("Error when trying to parse prediction data: ".concat(error));
          }

          if (prediction && prediction.prediction && Array.isArray(prediction.prediction) && prediction.prediction.length > 0 && prediction.prediction[0]) {
            var predictionItem = prediction.prediction[0];

            if (predictionItem.system === 'SROW') {
              var predictedOutcomes = predictionItem.outcomes;

              if (predictedOutcomes && Array.isArray(predictedOutcomes)) {
                toAppend.homeSelected = predictedOutcomes.indexOf('1') > -1;
                toAppend.drawSelected = predictedOutcomes.indexOf('X') > -1;
                toAppend.awaySelected = predictedOutcomes.indexOf('2') > -1;
              }
            }
          }
        }

        return _objectSpread({}, eventAnalysis, {}, toAppend);
      })
    });
  });
};

var mapAnalyzesByEvent = function mapAnalyzesByEvent(gameAnalyzes) {
  var analyzesByEvent = {};
  gameAnalyzes.forEach(function (gameAnalysis) {
    (gameAnalysis.gameAnalyses || []).forEach(function (eventAnalysis) {
      if (!eventAnalysis || !eventAnalysis.properties || !eventAnalysis.properties.cnt_eventNumber || typeof eventAnalysis.properties.cnt_eventNumber !== 'number' || !gameAnalysis.authorProfile) {
        return;
      }

      var eventNumber = eventAnalysis.properties.cnt_eventNumber;

      if (!analyzesByEvent[eventNumber]) {
        analyzesByEvent[eventNumber] = [];
      }

      analyzesByEvent[eventNumber].push({
        authorProfile: {
          authorLongName: gameAnalysis.authorProfile.authorLongName,
          id: gameAnalysis.authorProfile.id,
          images: gameAnalysis.authorProfile.images
        },
        awaySelected: eventAnalysis.awaySelected,
        body: eventAnalysis.body,
        drawSelected: eventAnalysis.drawSelected,
        homeSelected: eventAnalysis.homeSelected
      });
    });
  });
  return analyzesByEvent;
};

var getGameAnalyzes = function getGameAnalyzes(_ref) {
  var drawNumber = _ref.drawNumber,
      product = _ref.product,
      matchId = _ref.matchId,
      callback = _ref.callback;
  var cacheKey;

  if (matchId) {
    cacheKey = matchId;
  } else {
    cacheKey = "".concat(product, "_").concat(drawNumber);
  }

  if (!gameAnalyzes[cacheKey]) {
    gameAnalyzes[cacheKey] = {
      analyzes: []
    };
  } else if (gameAnalyzes[cacheKey].expires > new Date()) {
    callback(null, gameAnalyzes[cacheKey].analyzes, gameAnalyzes[cacheKey].analyzesByEvent);
    return;
  }

  var method;
  var options = {
    count: 20
  };

  if (matchId) {
    method = svs.content.shared.cms.getGameAnalyses;
    options.id = matchId;
    options.idType = 'match';
  } else {
    method = svs.content.shared.cms.getDrawAnalyses;
    options.id = drawNumber;
    options.product = product;
  }

  method(options, function (error, response) {
    if (error) {
      logger.error("Errored when trying to fetch draw analyzes ".concat(error));
      callback(error);
      return;
    }

    gameAnalyzes[cacheKey].expires = new Date(Date.now() + CACHE_EXPIRE);

    if (matchId) {
      var mappedAnalyzes = mapGameAnalyzes(response.result);
      gameAnalyzes[cacheKey].analyzes = mappedAnalyzes;
      callback(null, mappedAnalyzes);
    } else {
      var _mappedAnalyzes = mapDrawAnalyzes(response.result);

      var analyzesByEvent = mapAnalyzesByEvent(_mappedAnalyzes);
      gameAnalyzes[cacheKey].analyzes = _mappedAnalyzes;
      gameAnalyzes[cacheKey].analyzesByEvent = analyzesByEvent;
      callback(null, _mappedAnalyzes, analyzesByEvent);
    }
  });
};

setGlobal('svs.sport.gameAnalyzes', {
  getGameAnalyzes: getGameAnalyzes,
  logger: logger
});
 })(window);